export default __webpack_public_path__ + "static/media/alphies-random2.f3a00160.gif";